export default __webpack_public_path__ + "static/animation-breaking-good-4944ad871b058993476526cd011f0b57.mp4";